import { Navigate } from "react-router-dom";
import { getAccessToken } from "../utils";

const PrivateRoute = ({ children }: any) => {
  return getAccessToken() ? children : <Navigate to="/" />;
};
export default PrivateRoute;
